/******************************************************************
 * Archivo : client/src/queries/fetchAllRoles.js
 * Proyecto: CB30
 * Módulo  : Usuarios - Roles
 * Proceso : Consulta de todos los roles
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query RolesQuery {
    roles {
      id
      code
      label
      description
      active
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchAllRoles.js